import React from 'react';
import ATextareaItem from 'antd-mobile/lib/textarea-item';



export default class TextareaItem extends ATextareaItem {}
